const textFR = {
  home: "Accueil",
  boss: "Boss",
  grouilleurs: "Grouilleurs",
  grouilleur: "Grouilleur",
  bara: "Bara",
  sinistres: "Sinistres",
  transactions: "Transactions",
  messages: "Messages",
  promotions: "Promotions",
  corbeille: "Corbeille de tâches",
  parametres: "Paramètres",
  rechercher: "Rechercher",
  creer_bara: "Créer un bara",
  bara_recents: "Baras Récents",
  voir_bara: "Voir les baras",
  voir_plus: "Voir plus",
  activites: "Activités",
  tout_marquer_lu: "Tout marquer comme lus",
  tout_effacer: "Tout effacer",
  bonjour: "Bonjour",
  votre_email: "Votre adresse mail",
  motdepasse: "Mot de passe",
  se_souvenir_moi: "Se souvenir de moi",
  se_connecter: "Se connecter",
  motdepasse_oublie: "Mot de passe oublié ?",
  motdepasse_confirmer: "Confirmer mot de passe",
  bienvenue: "Bienvenue !",
  bienvenue_desc: "Vous avez reçu un mail d'inscription pour Jevebara, veuillez enregistrer un mot de passe pour finaliser la création de votre compte",
  enregistrer: "Enregistrer",
  motdepasse_reinitialiser: "Réinitialisation du mot de passe",
  motdepasse_reinitialiser_desc: "Veuillez renseigner l’adresse mail avec laquelle vous avez crée votre compte",
  recevoir_code: "Reçevoir le code",
  revenir_connexion: "Revenir à la page de connexion",
  verification_otp: "Vérification OTP",
  verification_email: "Nous avons envoyé un code à l’adresse",
  verification_changer: "Cet email n’est pas le votre ?",
  changer: "changer",
  verification_spam: "Vous n’avez pas reçu de mail ? vérifiez votre boîte de spam",
  valider: "Valider",
  nouveau_motdepasse: "Nouveau mot de passe",
  nouveau_motdepasse_desc: "Définissez un nouveau mot de passe",
  confirmer: "Confirmer",
  motdepasse_reinitialiser_alt: "Réinitialiser mot de passe",
  dossiers: "Dossiers",
  mes_dossiers_personnels: "Mes dossiers personnels",
  dossier_group: "Dossiers de groupe",
  nom_du_bara: "Nom du bara",
  nom_boss: "Nom du boss",
  telephone: "Téléphone",
  statut: "Statut",
  reaffecter: "Réaffecter",
  list_charge_affaire: "Liste des chargés d’affaire",
  par_pages: "Par pages",
  details_bara: "Détails du bara",
  intitule_bara: "Intitulé du bara",
  categorie_souscat: "Catégorie/Sous catégorie",
  localisation_bara: "Localisation du bara",
  description_bara: "Description du bara",
  photo_lieux: "Photos des lieux",
  informations_positionnement: "Informations sur les positionnements",
  proposer_grouilleur: "Proposer un grouilleur",
  detail_boss: "Détails du boss",
  adress_bara: "Adresse du bara",
  details_grouilleur: "Détails du Grouilleur",
  nom_grouilleur: "Nom du Grouilleur",
  localisation: "Localisation",
  rechercher_grouilleur: "Rechercher un grouilleur",
  appliquer_recherche: "Appliquer la recherche",
  affecter_grouilleur: "Affecter un grouilleur",
  affecter_grouilleur_bara: "Affecter un grouilleur au bara",
  proposer: "Proposer",
  considerer_bara_ouvert: "Considérer le bara comme ouvert ?",
  list_grouilleurs: "Liste des grouilleurs",
  filtrer: "Filtrer",
  oui: "Oui",
  non: "Non",
  mes_dossiers: "Mes dossiers",
  list_boss: "Liste des boss",
  creer_boss: "Créer un boss",
  filtrer_par: "Filtrer par",
  exporter_liste: "Exporter liste",
  supprimer: "Supprimer",
  actif: "Actif",
  tout_afficher: "Tout afficher",
  bloquer: "Bloquer",
  bloque: "Bloqué",
  motif_blocage: "Motif du blocâge",
  date_debut: "Date de début",
  date_fin: "Date de fin",
  motif_blocage_desc: "Veuillez renseigner le motif du blocage",
  ajouter_un_boss: "Ajouter un boss",
  ajouter_boss: "Ajouter boss",
  prenom: "Prénom",
  nom: "Nom",
  informations_basique: "Informations basiques",
  verifier: "Vérifier",
  cree_le: "Crée le",
  informations_financieres: "Informations financières",
  points_fidelite: "Points de fidelités",
  credit: "Crédit",
  crediter: "Créditer",
  debiter: "Débiter",
  informations_bara: "Informations sur ses bara",
  id_bara: "ID du bara",
  categorie: "Catégorie",
  sous_categorie: "Sous-catégorie",
  intitule: "Intitulé",
  gestionnaire: "Gestionnaire",
  en_cours: "En cours",
  termine: "Terminé",
  historique_blocage_deblocage: "Historique des blocages et déblocages",
  activite: "Activité",
  auteur: "Auteur",
  motif: "Motif",
  deconnecter_user: "Déconnecter l’utilisateur",
  particularite_boss: "Particularité du Boss",
  note: "Note",
  attache_a: "Attaché à",
  list_bara: "Liste des Bara",
  detail_bara: "Detail du bara",
  changer_statut: "Changer le statut",
  rows_per_page: "rangées par page",
  preference_bara: "Préférence de bara",
  positionnement: "Positionnement",
  positionner: "Positionner",
  creer_un_grouilleur: "Créer un grouilleur",
  creer_grouilleur: "Créer grouilleur",
  date_besoin: "Date besoin",
  list_sinistres: "Liste des sinistres",
  list_transactions: "Liste des transactions",
  nouvelle_transaction: "Nouvelle transaction",
  date: "Date",
  valeur: "Valeur",
  type: "Type",
  ajouter_transaction: "Ajouter une transaction",
  list_promotions: "Liste des promotions",
  nouvelle_promotion: "Nouvelle promotion",
  libelle: "Libellé",
  regle_definir: "Règles à définir",
  reduction: "Réduction",
  cible: "Cible",
  code_promo: "Code promo",
  creer_promotion: "Créer une promotion",
  creer_la_promotion: "Créer la promotion",
  mes_taches: "Mes tâches",
  taches: "Tâches",
  createur: "Créateur",
  responsable: "Responsable",
  gestion_mot_pass: "Gestion mot de passe",
  gestion_users: "Gestion des utilisateurs",
  categories: "Catégories",
  mdp_actuel: "Mot de passe actuel",
  nouveau_mot_pass: "Nouveau mot de passe",
  confirmer_mot_pass: "Confirmer mot de passe",
  page_not_found: "La page demandée n'existe pas",
  charge_affaire: "Chargé d’affaire",
  rechercher_conversation: "Rechercher une conversation",
  invalid_password: "Nom d'utilisateur ou mot de passe incorrect",
  ajouter_bara: "Ajouter un bara",
  date_demarrage_souhaite: "Date de démarrage souhaitée",
  select_grouilleur_pref: "Avez-vous un grouilleur de préférence",
  liberer_tache: "Libérer la tâche",
  refuser_tache: "Refuser la tâche",
  uploader_photos: "Uploader les photos",
  gestionnaire_bara: "Gestionnaire de bara",
  createur_bara: "Créateur du bara",
  affecter_bara: "Affecter le bara à",
  cancel: "Annuler",
  save_bara: "Enregistrer Bara",
  grouilleur_doit: "Le grouilleur doit venir",
  avec_materiel: "Avec son matériel",
  sans_materiel: "Sans matériel",
  previsite_lieu: "Pré-visite du lieu",
  devis: "Devis",
  mode_paiement: "Mode de paiement",
  cash: "Cash",
  wallet: "Wallet",
  taux_reduction: "Taux de réduction",
  role: "Rôle",
  creer_utilisateur: "Créer un utilisateur",
  administrateur: "Administrateur",
  manager: "Manager",
  financier: "Financier",
  operationnel: "Opérationnel",
  creer_offre: "Créer une offre",
  valider_transaction: "Valider une transaction",
  annuler_transaction: "Annuler une transaction",
  attribuer_tache: "Attribuer les tâches",
  mise_relation: "Mise en relation",
  utilisateurs: "Utilisateurs",
  operateur: "Opérateur",
  creer_user: "Créer un nouvel utilisateur",
  update_user: "Modifier un utilisateur",
  ajouter: "Ajouter",
  createur_transaction: "Créateur de la transaction",
  montant: "Montant",
  emetteur: "Emetteur",
  numero_transaction: "Numéro de la transaction",
  nom_prenom_emetteur: "Nom et prénom de l’émetteur",
  supprimer_desc: "Vous êtes sur le point de supprimer cet utilisateur Cela entrainera la perte de toute ses données.",
  supprimer_ok: "Oui, supprimer",
  error_occured: "une erreur est survenue",
  update_success: "Mise à jour réussie",
  create_success: "créé avec succès",
  delete_success: "supprimé avec succès",
  definissez_regle: "Définissez une règle",
  BOSS: "Boss",
  GROUILLEUR: "Grouilleur",
  TOUS: "Tous",
  TAUX_COMMISSION: "Taux commission",
  CAGNOTTE: "Cagnotte",
  CAUTION: "Caution",
  LIVRAISON_GRATUITE: "Livraison gratuite",
  no_data: "Aucune données disponible",
  EN_ATTENTE: "En attente",
  DEBIT: "Débit",
  CREDIT: "Crédit",
  nom_bara: "Nom bara",
  NON_TRAITER: "Non traité", 
  VALIDER: "Validé", 
  REFUSER: "Refusé",
  ANNULER: "Annulé",
  mes_affaires: "Mes affaires",
  afficher_message_nonlu: "Afficher les messages non lus",
  tout_marquer: "Tout marquer comme lu",
  tout_marquer_non: "Tout marquer comme non lu",
  profile: "Profile",
  email: "Email",
  update_picture: "Modifier la photo",
  UTILISATEUR: "Utilisateur", 
  ADMIN: "Admin", 
  MANAGER: "Manager", 
  FINANCIER: "Fiancier", 
  OPERATIONNEL: "Operationnel", 
  modifier: "Modifier",
  transaction_detail: "Détail de la transaction",
  details: "Détails",
  reference_fichier: "Fichier référence",
  date_creation: "Date de création",
  creer_categorie: "Créer Catégorie",
  update_categorie: "Modifier Catégorie",
  logout: "Déconnexion",
  type_solde: "Type solde",
  type_service: "Type service",
  session_expire: "Session expiré",
  session_expire_desc: "Veuillez vous connecter a nouveau",
  type_operation: "Type operation",
  MTN_MONEY: "Mtn money",
  INTERNE: "Interne",
  ORANGE_MONEY: "Orange money",
  CASH: "Cash",
  MOOV_MONEY: "Moov money",
  WAVE: "Wave",
  PREVISITE: "Previsite",
  POSITIONNEMENT: "Positionnement",
  PARRAINAGES: "Parraingages",
  EFFECTUER: "Effectuer",
  status: "Status",
  EN_COURS: "En cours",
  TERMINER: "Terminer",
  ACTIF: "Actif",
  NON_ACTIF: "Non actif",
  PAIEMENT_ELECTRONIQUE: "Paiement electronique",
  ANNEE_EN_COURS: "Année en cours", 
  JOUR_EN_COURS: "Jour en cours", 
  MOIS_EN_COURS: "Mois en cours",
  numero_telephone: "Numéro de téléphone",
  affecter: "Affecter",
  A_VERIFIER: "A Vérifier",
  activer: "Activer",
  rechercher_bara: "Rechercher un bara",
};

export default textFR;
